(() => {
  'use strict';
  if (customElements.get('mv-inline-reviews')) return;
  customElements.define('mv-inline-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.viewport = this.querySelector('[data-review-viewport]');
      this.previous = this.querySelector('[data-review-prev]');
      this.next = this.querySelector('[data-review-next]');
      if (!this.viewport || !this.previous || !this.next) return;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = false;
      this.hovered = false;
      this.focused = false;
      this.dragging = false;
      const listen = (element, event, handler) => element.addEventListener(event, handler, options);
      listen(this.previous, 'click', () => {this.move(-1); this.schedule();});
      listen(this.next, 'click', () => {this.move(1); this.schedule();});
      listen(this.viewport, 'scroll', () => this.update());
      listen(this.viewport, 'keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); this.move(event.key === 'ArrowRight' ? 1 : -1);
        }
      });
      listen(this, 'pointerenter', event => {if (event.pointerType !== 'touch') {this.hovered = true; this.schedule();}});
      listen(this, 'pointerleave', () => {this.hovered = false; this.schedule();});
      listen(this, 'focusin', () => {this.focused = true; this.schedule();});
      listen(this, 'focusout', event => {this.focused = this.contains(event.relatedTarget); this.schedule();});
      listen(this.viewport, 'pointerdown', event => {
        if (event.pointerType === 'touch' || event.button !== 0) return;
        this.dragging = true;
        this.startX = event.clientX;
        this.startScroll = this.viewport.scrollLeft;
        this.viewport.setPointerCapture(event.pointerId);
        this.viewport.classList.add('is-dragging');
        this.schedule();
      });
      listen(this.viewport, 'pointermove', event => {
        if (this.dragging) this.viewport.scrollLeft = this.startScroll - (event.clientX - this.startX);
      });
      const release = () => {
        this.dragging = false;
        this.viewport.classList.remove('is-dragging');
        this.schedule();
      };
      listen(this.viewport, 'pointerup', release);
      listen(this.viewport, 'pointercancel', release);
      listen(this.viewport, 'lostpointercapture', release);
      listen(document, 'visibilitychange', () => this.schedule());
      listen(this.motion, 'change', () => this.schedule());
      this.resize = new ResizeObserver(() => this.update());
      this.resize.observe(this.viewport);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.schedule();
      }, {threshold: .25});
      this.observer.observe(this);
      this.update();
    }
    update() {
      const max = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
      this.previous.disabled = this.viewport.scrollLeft <= 2;
      this.next.disabled = this.viewport.scrollLeft >= max - 2;
    }
    move(direction, loop = false) {
      const cards = [...this.querySelectorAll('.mv-inline-reviews__card')];
      if (!cards.length) return;
      const step = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : cards[0].offsetWidth;
      const max = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
      const left = loop && this.viewport.scrollLeft >= max - 2 ? 0 : Math.max(0, Math.min(max, this.viewport.scrollLeft + direction * step));
      this.viewport.scrollTo({left, behavior: this.motion.matches ? 'auto' : 'smooth'});
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.dataset.autoplay !== 'true' || this.motion.matches || !this.visible || document.hidden || this.hovered || this.focused || this.dragging) return;
      this.timer = setTimeout(() => {this.move(1, true); this.schedule();}, Math.max(3, Number(this.dataset.interval) || 4) * 1000);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.resize?.disconnect();
      this.observer?.disconnect();
      this.controller = null;
    }
  });
})();
